var _rect, _rect2, _circle, _path, _path2, _circle2, _circle3, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChrisAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 48,
    fill: "#0F172A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 32,
    width: 448,
    height: 448,
    rx: 40,
    fill: "url(#bg)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 210,
    r: 106,
    fill: "#E9BC96"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154 182C154 118 202 82 258 82C320 82 362 126 362 184V220H154V182Z",
    fill: "#111827"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M162 398C180 326 220 296 256 296C292 296 332 326 350 398V428H162V398Z",
    fill: "#0EA5E9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 218,
    cy: 204,
    r: 10,
    fill: "#111827"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 292,
    cy: 204,
    r: 10,
    fill: "#111827"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M222 246C236 256 274 256 288 246",
    stroke: "#7C2D12",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M206 170C218 164 230 162 240 166",
    stroke: "#374151",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M274 166C284 162 296 164 308 170",
    stroke: "#374151",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M190 128C222 110 300 108 332 130",
    stroke: "#38BDF8",
    strokeWidth: 16,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M190 264C218 286 296 286 322 264",
    stroke: "#082F49",
    strokeWidth: 10,
    strokeLinecap: "round",
    opacity: 0.45
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 70,
    y1: 64,
    x2: 444,
    y2: 448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0EA5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#0284C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22C55E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrisAvatar);
export default __webpack_public_path__ + "static/media/chris-avatar.d0787390160a0569cfd3f4ffc53ae1c6.svg";
export { ForwardRef as ReactComponent };